import { render, staticRenderFns } from "./VerifyMessage.vue?vue&type=template&id=668b7bde&scoped=true"
import script from "./VerifyMessage.vue?vue&type=script&lang=js"
export * from "./VerifyMessage.vue?vue&type=script&lang=js"
import style0 from "./VerifyMessage.vue?vue&type=style&index=0&id=668b7bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b7bde",
  null
  
)

export default component.exports